export default "__VITE_ASSET__BWJzp55A__"